import { useMutation } from "react-query";
import useApi from "./useApiRequest";

export const VerifyAnswerCheckAlmacen = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/cuestionarios/respuestas/almacen/${params.id}?startDate=${params.startDate}&endDate=${params.endDate}`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    verifyAnswerCheckAlmacenMutation: mutation.mutate,
  };
}

export const VerifyCheckAlmacen = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/cuestionarios/rework/verification/almacen/${params.id}?startDate=${params.startDate}&endDate=${params.endDate}`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    verifyCheckAlmacenMutation: mutation.mutate,
  };
}

export const AnswerCuestionario = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/cuestionarios/respuestas/healtcheck`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    answerCuestionarioMutation: mutation.mutate,
  };
}